import Serializer from '@contently/simple-json-api-resource-seralizer';
import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { stringify } from 'qs';

const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.apiError = true;
  error.response = response;
  throw error;
};

const parseJson = response => response.json();

const request = (method, endpoint, body, isJsonApi = false) => {
  const options = {
    method,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    }
  };

  if (body) {
    options.body = body;
  }

  let response = (window.fetch || fetchPolyfill)(endpoint, options)
    .then(checkStatus)
    .then(parseJson);

  if (isJsonApi) {
    const mapper = new Serializer();
    response = response.then(json => mapper.deserialize(json));
  }

  return response;
};

const get = (endpoint, isJsonApi = true) => request('GET', endpoint, null, isJsonApi);
const post = (endpoint, body, isJsonApi = false) => request('POST', endpoint, body, isJsonApi);
const patch = (endpoint, body, isJsonApi = false) => request('PATCH', endpoint, body, isJsonApi);

const endpoint = (urlStr, params = {}) => {
  let location = urlStr;

  if (params && Object.keys(params).length) {
    location += '?';
    location += stringify(params);
  }

  return location;
};

export { get, post, patch, endpoint };



// WEBPACK FOOTER //
// ./app/javascript/app/utils/api.js